<template>
  <div ref="container">
    <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container"
             :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             :ok-button-props="{ disabled: true }" @ok="handleOk" @cancel="handleCancel"  style="top:10%;height: 80%;">
      <template slot="footer">
        <a-button key="back"  @click="handleCancel">
          关闭
        </a-button>
        <a-button key="back" :disabled="isReadOnly" @click="handleOk" type="primary">
          确定
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-card>
          <span class="title">产品标识信息</span>
          <a-descriptions>
            <a-descriptions-item label="产品DI">{{form.productDi}}</a-descriptions-item>
            <a-descriptions-item label="产品标识体系编码名称">{{form.codeSystem == 1 ? 'MA(IDcode)' : 'GS1'}}</a-descriptions-item>
            <a-descriptions-item label="产品名称">{{form.productName}}</a-descriptions-item>
            <a-descriptions-item label="分类编码">{{form.categoryCode}}</a-descriptions-item>
            <a-descriptions-item label="包装规格">
              {{form.specificationName}}
            </a-descriptions-item>
            <a-descriptions-item label="器械类别">
              <span v-if="form.deviceCategory == 1">器械</span>
              <span v-else-if="form.deviceCategory == 2">体外诊断试剂</span>
            </a-descriptions-item>
          </a-descriptions>

        </a-card>
        <a-card style="margin-top:30px;">
          <span class="title">产品PI信息</span>
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号长度" prop="serialLength">
                  <a-input style="width:90%;" placeholder="请输入序列号长度" v-model="form.serialLength" />
                  <a-tooltip placement="right" title="请输入序列号长度，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号前缀" prop="serialPrefix">
                  <a-input style="width:90%;" placeholder="请输入序列号前缀" v-model="form.serialPrefix" />
                  <a-tooltip placement="right" title="请输入序列号前缀,仅支持字母、数字、部分字符">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号起始号" prop="serialStartNum">
                  <a-input style="width:90%;" placeholder="请输入序列号起始号" v-model="form.serialStartNum" />
                  <a-tooltip placement="right" title="请输入序列号起始号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号终止号" prop="serialEndNum">
                  <a-input style="width:90%;" placeholder="请输入序列号终止号" v-model="form.serialEndNum" />
                  <a-tooltip placement="right" title="请输入序列号终止号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="startDate">
                  <j-date v-model="form.startDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择生产日期" :show-time="true" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产批号" prop="batchNumber">
                  <a-input style="width:90%;" placeholder="请输入生产批号" v-model="form.batchNumber" />
                  <a-tooltip placement="right" title="请输入生产批号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="灭菌批号" prop="dBatchNumber">
                  <a-input style="width:90%;" placeholder="请输入灭菌批号" v-model="form.dBatchNumber" />
                  <a-tooltip placement="right" title="请输入灭菌批号,仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="失效日期" prop="endDate">
                  <j-date v-model="form.endDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择失效日期" :show-time="true" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效日期" prop="effectiveDate">
                  <j-date v-model="form.effectiveDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择有效日期" :show-time="true" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-card>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import JDate from '@/components/jeecg/JDate'
import { addPIinfo, insertProductPI } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDate,
  },
  data() {
    var checkSerial = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!/^[0-9]{1,9}$/g.test(value)) {
        // /^[0-9]{1,10}$/g
        return callback(new Error('最多只能输入9位数字'))
      } else {
        callback()
      }
    }
    var checkPrefix = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!/^[A-Za-z0-9-@$,*+%#!^~]{1,9}$/g.test(value)) {
        // /^[0-9]{1,10}$/g
        return callback(new Error('最多只能输入9位字母、数字或字符'))
      } else {
        callback()
      }
    }
    var checkBatch = (rule, value, callback) => {
      if (value && !/^[A-Za-z0-9-@$,*+%#!^~]{1,20}$/g.test(value)) {
        return callback(new Error('最多只能输入20位字母、数字或字符'))
      } else {
        callback()
      }
    }
    return {
      title: '生成PI',
      visible: false,
      fileList: [],
      model: {},
      headers: { 'X-Access-Token': '123' },
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },

      confirmLoading: false,
      form: {
        serialLength: '4',
        serialPrefix: '',
        serialStartNum: '1',
        serialEndNum: '',
        startDate: '',
        batchNumber: '',
        dBatchNumber: '',
        endDate: '',
        effectiveDate: '',
        codeSystem: '',
      },
      queryform: {},
      rules: {
        serialLength: [
          {
            required: false,
            validator: checkSerial,
            // message: '请选择生产日期',
            trigger: 'blur',
          },
        ],
        serialPrefix: [
          {
            required: false,
            // serialPrefix:checkSerial,
            validator: checkPrefix,
            trigger: 'blur',
          },
        ],
        serialStartNum: [
          {
            required: false,
            validator: checkSerial,
            trigger: 'blur',
          },
        ],
        serialEndNum: [
          {
            required: false,
            validator: checkSerial,
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: false,
            message: '请选择生产日期',
            trigger: 'change',
          },
        ],
        batchNumber: [
          {
            required: false,
            validator: checkBatch,
            // message: '生产批号不能为空',
            trigger: 'blur',
          },
        ],
        dBatchNumber: [
          {
            required: false,
            validator: checkBatch,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {},
  methods: {
    // 如果月或日小于10,在前面补0
    padZero(num) {
      return num < 10 ? "0" + num : num;
    },
    alldatatoshut(val){
      // 获取年、月、日
      let year = val.getFullYear();
      let month = val.getMonth() + 1; // 月份从0开始,所以需要加1
      let day = val.getDate();

      // 格式化日期为 YYYY-MM-DD 的形式
      let formattedDate = year + "-" + this.padZero(month) + "-" + this.padZero(day);

      return formattedDate
    },
    add(record) {
      this.edit(record)
    },
    async edit(record) {
      this.isReadOnly = false
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      this.visible = true
      if (record.id && record.specificationId) {
        this.queryform = {
          productId: record.id,
          specificationId: record.specificationId,
        }
        const res = await addPIinfo(this.queryform)
        if (res.errno == 200 && res.errmsg === '成功') {
          console.log(res.data)
          if(res.data.specificationName?res.data.specificationName.split(':')[1]:''){
            const number = res.data.specificationName.split(':')[1]
            if(number == '0'){
              res.data.serialLength = 5
            }else if(number == '1'){
              res.data.serialLength = 4
            }else if(number == '2'){
              res.data.serialLength = 3
            }
            res.data.serialStartNum = 1
          }

          //默认生产日期
          res.data.startDate = this.alldatatoshut(new Date())

          //默认失效日期
          const endDate = new Date()
          endDate.setFullYear(endDate.getFullYear() + 1);
          res.data.endDate = this.alldatatoshut(endDate)

          //默认有效日期
          const effectiveDate = new Date()
          effectiveDate.setFullYear(effectiveDate.getFullYear() + 1);
          effectiveDate.setDate(effectiveDate.getDate() - 1);
          res.data.effectiveDate = this.alldatatoshut(effectiveDate)

          this.form = res.data
        } else {
          this.$message.error(res.errmsg)
        }
      }
      this.$nextTick(() => {})
    },

    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {

          if(this.form.serialStartNum > this.form.serialEndNum){
            this.$message.warning('起始数值不能大于终止数值')
            return false
          }

          const params = {
            productId: this.queryform.productId.toString(),
            specificationId: this.queryform.specificationId.toString(),
            serialLength: this.form.serialLength || '',
            serialPrefix: this.form.serialPrefix || '',
            serialStartNum: this.form.serialStartNum || '',
            serialEndNum: this.form.serialEndNum || '',
            startDate: this.form.startDate || '',
            batchNumber: this.form.batchNumber || '',
            dBatchNumber: this.form.dBatchNumber || '',
            endDate: this.form.endDate || '',
            effectiveDate: this.form.effectiveDate || '',
            codeSystem: this.form.codeSystem|| '',
          }
          this.isReadOnly = true
          const res = await insertProductPI(params)

          if (res.errno == 200 && res.errmsg === '成功') {
            this.$message.success(res.errmsg)
            this.close()
          } else {
            this.isReadOnly = false
            this.$message.error(res.errmsg || res.data)
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
.title {
  /* /* margin-left: 30px; */
  font-size: 24px;
  font-weight: 700;
}
</style>
